import React from 'react'
import { connect } from 'react-redux'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Modal, ErrorBoundary } from 'components'

function Share(props) {
  const url = `https://plan.capitalmindwealth.com/shared/${props.sessionId}`
  return (
    <Modal title={'Share with others'} handleClose={() => props.history.replace("/")}>
      <div className="share">
        <ErrorBoundary>
          <div>Visit this unique URL to view your financial plan</div>
          <div className="share__url">
            <span>{url}</span><br/>
            <CopyToClipboard text={url}>
              <span className="share__copy">Copy</span>
            </CopyToClipboard>
          </div>
          <div>
            <button onClick={() => props.history.replace("/")}>Done</button>
          </div>
        </ErrorBoundary>
      </div>
    </Modal>
  )
}

export default connect(
  state => ({ sessionId: state.session.id })
)(Share)




// WEBPACK FOOTER //
// ./src/components/modals/Share.js